import env from '../../../../env';
import { AppClientId } from '../../../Shared/constants';

const INDEWAL_COMPANY_DATA = {
  name: "In de Wal Auto's B.V.",
  addressLine1: 'Kleefstraat 8',
  postcodeAndPlace: '8028 PR Zwolle',
  tel: '088-0038000',
  eMail: 'finance@indewal.nl',
  web: 'www.indewal.nl',
  IBAN: 'NL41RABO0127803025',
  BIC: 'RABONL2U',
  BTW: 'NL800235903B01',
  KVK: '05049414',
};

const IDWGMBH_COMPANY_DATA = {
  name: 'In de Wal GmbH',
  addressLine1: 'Limburger Tor 114-117',
  postcodeAndPlace: '47652 Weeze',
  tel: '+31(0)88 0038 030',
  eMail: 'finanzen@indewalgmbh.de',
  web: 'www.indewal.de',
  IBAN: 'DE27 5021 0295 0503 0001 17',
  BIC: 'RABODEFFXXX',
  BTW: 'NL800235903B01',
  KVK: '05049414',
  Steuernummer: '113/5720/3402',
  UStIDNr: 'DE309074573',
};

const WIENTJES_COMPANY_DATA = {
  name: 'Auto Wientjes B.V.',
  addressLine1: 'Veenhuizerweg 132',
  postcodeAndPlace: '7325 AM Apeldoorn',
  tel: '+31 (0)55 - 323 16 35',
  eMail: 'info@autowientjes.nl',
  web: 'www.autowientjes.nl',
  IBAN: 'NL66 ABNA 0523 3098 13',
  BIC: 'ABNANL2A',
  BTW: 'NL816963575B01',
  KVK: '08147652',
};



const HOOIKAMMER_COMPANY_DATA = {
  name: 'Hooikammer FleetServices B.V.',
  addressLine1: 'Oostermeentherand 10',
  postcodeAndPlace: '8332 JZ Steenwijk',
  tel: '088 - 24 24 724',
  eMail: 'info@hooikammergroep.nl',
  web: 'www.hooikammergroep.nl',
  IBAN: 'NL93 INGB 0652 8093 16',
  BIC: 'INGBNL2A',
  BTW: '',
};

const HARRY_NIJBOER_COMPANY_DATA = {
  name: 'Autobedrijf Harry Nijboer B.V.',
  addressLine1: 'Handelsweg 2',
  postcodeAndPlace: '8152 BN',
  tel: '0572 378750',
  eMail: 'info@harrynijboer.nl',
  web: 'www.harrynijboer.nl',
  IBAN: 'NL57 RABO 0127 8261 14',
  BIC: 'RABONL2U',
  BTW: 'NL8084.36.880.B01',
  KVK: '05047365',
};


const AUTOHUISSALLAND_COMPANY_DATA = {
  name: 'Autohuis Salland',
  addressLine1: 'Stationsstraat 11',
  postcodeAndPlace: '8152 BH Lemelerveld',
  tel: '+31 038 - 20 22 370',
  eMail: 'info@autohuissalland.nl',
  web: 'www.autohuissalland.nl',
  IBAN: 'NL864099654B01',
  BIC: 'RABONL2U',
  BTW: 'NL864099654B01',
  KVK: '86823574',
};

const IDWLEASE_COMPANY_DATA = {
  name: "IDW Lease B.V.",
  addressLine1: 'Kleefstraat 8',
  postcodeAndPlace: '8028 PR Zwolle',
  tel: '088-0038000',
  eMail: 'finance@indewal.nl',
  web: 'www.indewal.nl',
  IBAN: '-',
  BIC: 'RABONL2U',
  BTW: 'NL856791532B01',
  KVK: '67007821',
};



let data = {};
switch (env.clientId) {
  case AppClientId.INDEWAL:
    data = INDEWAL_COMPANY_DATA;
    break;
  case AppClientId.IDW_GMBH:
    data = IDWGMBH_COMPANY_DATA;
    break;
  case AppClientId.HARRY_NIJBOER:
    data = HARRY_NIJBOER_COMPANY_DATA;
    break;
  case AppClientId.AUTOWIENTJES:
    data = WIENTJES_COMPANY_DATA;
    break;
  case AppClientId.HOOIKAMMER:
    data = HOOIKAMMER_COMPANY_DATA;
    break;
    case AppClientId.AUTOHUISSALLAND:
      data = AUTOHUISSALLAND_COMPANY_DATA;
      break;
      case AppClientId.IDWLEASE:
        data = IDWLEASE_COMPANY_DATA;
        break;
}

export default data;
